import React, { Component } from 'react'
import PageHead from '../../components/pageHead';
import Layout from '../../components/Layout';
import '../../sass/_case-study.scss';
import '../../sass/_home.scss';
import TalkData from '../../components/talk-data';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Header from '../../components/header';
import Link from 'next/link';

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            navList: [
                {
                    "id": 1,
                    "name": 'All',
                    "nav_active": true
                },
                {
                    "id": 2,
                    "name": 'Food and Beverage',
                    "nav_active": false
                },
                {
                    "id": 3,
                    "name": 'Retail',
                    "nav_active": false
                },
                {
                    "id": 4,
                    "name": 'Manufacturing',
                    "nav_active": false
                },
                {
                    "id": 5,
                    "name": 'Pharma',
                    "nav_active": false
                },
                {
                    "id": 6,
                    "name": 'Real Estate',
                    "nav_active": false
                },
                {
                    "id": 7,
                    "name": 'Healthcare',
                    "nav_active": false
                }
            ],
            navItemsList: [
                {
                    "id": 7,
                    "name": 'Greyn',
                    "content": <span>A global leader in road traffic analytics, Greyn’s requirement began 
                        with brand positioning. They aspired for their brand to appear at the scale of 
                        the impact their work in traffic analytics was  <span class="read-more-target">creating globally. Our UI and 
                        creative teams began understanding their product from the roots, in order to create 
                        a fresh look for the brand, projecting their strengths through their website. 
                        In addition, our UI and analytics teams also brainstormed to put together a nimble 
                        UI design that provides powerful insights at the very first look.
                    </span></span>,
                    "ads": 'Strategy & research  |  UI UX Design  |  Visual & web design  |  Erp solutions web applications',
                    "image": 'Greyn-axlrdata.png',
                    "alt": 'bbg-axlr',
                    "isActive": true,
                    "cat_sulg":'BBG',
                    "show":true
                },
                {
                    "id": 8,
                    "name": 'Hooper Labs',
                    "content": <span>A SaaS startup, Hooper Labs is building a low code/no-code BPM 
                        (Business Process Management) automation tool for industries. Aspiring to be 
                        a global brand, Hooper Labs required a fresh website for  <span class="read-more-target">their participation
                         at the Mobile World Congress, 2018. Our designers, content writers and developers
                          hustled to ideate and provide a very progressive look to the website, one 
                          that allures every individual, set at global standards. Hooper Labs received 
                          beyond expected response from their participation at the MWC and has begun to 
                          serve clients from all around the globe.
                    </span></span>,
                    "ads": 'Strategy & research  |  UI UX Design  |  Visual & web design  |  Erp solutions web applications',
                    "image": 'Hooper-Labs-axlrdata.png',
                    "alt": 'bbg-axlr',
                    "isActive": true,
                    "cat_sulg":'BBG',
                    "show":true
                },
                {
                    "id": 1,
                    "name": 'Charminar Restaurant',
                    "content": <span>Charminar takes pride in bringing to you the authentic South Indian taste with 
                        a wide variety of dishes. They are the only restaurant in Canada to cater 30 varieties of 
                        Biryanis and Dosas that are<span class="read-more-target"> “cooked to perfection”. For Charminar Indian Cuisine, our team 
                        created the logo, menu, website and social media creatives keeping in mind the South Indian 
                        offerings. Campaigns and posts were created and widely popularised over social media. 
                        The focus on this has enabled the restaurant to be Canda's #1 Indian restaurant.</span></span>,
                    "ads": 'Strategy & research  |  UI UX Design  |  Visual & web design  |  Erp solutions web applications',
                    "image": 'charminor-axlr.png',
                    "alt": 'charminor-axlr',
                    "isActive": true,
                    "cat_sulg":'charminar',
                    "show":true
                },
                {
                    "id": 5,
                    "name": 'Godavari Restaurant',
                    "content": <span>A US-based restaurant chain specialising in flavours and aroma from Southern India, 
                        Godavari has emerged as the go-to hub for Indians to kindle their taste buds. We are proud to be 
                        a part of their<span class="read-more-target"> journey, growing from a single restaurant to a franchise of 25 restaurants in 
                        the US, growing their digital presence through branding and social media marketing, 
                        building an AI-assisted POS system to bring intelligence into restaurant management 
                        and a cloud-based Franchise Management System to ensure quality and consistency in service 
                        being provided at every location.</span></span>,
                    "ads": 'Strategy & research  |  UI UX Design  |  Visual & web design  |  Erp solutions web applications',
                    "image": 'godavari-axlr.png',
                    "alt": 'godavari-axlr',
                    "isActive": true,
                    "cat_sulg":'Godavari',
                    "show":true
                },
            ]
        }
    }

    navAcive(item) {
        this.state.navList.forEach(element => {
            if (element.id == item.id) {
                element.nav_active = true
                if (item.id == 1) {
                    this.state.navItemsList.forEach(elementE => {
                        elementE.isActive = true
                    });
                } else {
                    this.state.navItemsList.forEach(elementS => {
                        if (elementS.id == 2 || elementS.id == 4 || elementS.id == 6) {
                            elementS.isActive = true
                        } else {
                            elementS.isActive = false
                        }
                    });
                }
            } else {
                element.nav_active = false
            }
        });
        var finalData = this.state.navList
        var finalDataL = this.state.navItemsList
        this.setState({
            navList: finalData,
            navItemsList: finalDataL
        })
    }

    render() {
        let { navList, navItemsList } = this.state
        return (
            <div>
                <Header name="case-studies" />
                <PageHead title="AXLR DATA PVT LTD | Software Solutions"></PageHead>
                <Layout>
                    <section className="devalopement-sec">
                        <Container>
                            <div className="mb-sm-5 pt-5 pb-sm-5">
                                <Row>
                                    <Col className="pr-sm-0" md>
                                        <div className="pl-sm-1 mt-sm-5">
                                            <div className="big-heading pt-2 csd-head">Our Work</div>
                                            <div className="spectial-content pt-sm-5">
                                                Turning ideas into solutions through elegant design and robust
    technology
                                           </div>
                                            {/* <div className="spectial-content">
                                               points and thus, arrive at a real time solution.
                                           </div> */}
                                        </div>
                                    </Col>
                                    <Col className="text-center">
                                    <div className="spectial-content pt-5 ta9990pj">We don't make users</div>
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/ezgif.com-gif-maker.gif`} alt="Path" className="ml-sm-1 mobile-wi-c" />
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </section>
                    <section>
                        <Container>
                            <br className="mobile" />
                            <br className="mobile" />
                            <Row>
                                {/* <Col md={3} className="">
                                    <div className="side-nav-box pl-sm-4 pb-sm-5">
                                        <div className="category-heading pl-sm-3">Categories</div>
                                        {navList.map((items, index) => (
                                            <div key={index} onClick={() => this.navAcive(items)} className="pt-sm-3 pl-sm-3">
                                                <Row className="link-action">
                                                    <Col md={1}>
                                                        {items.nav_active ? <div className="actieBox">
                                                            <div className="actieBox-sm"></div>
                                                        </div> : <span className="round-box"></span>}
                                                    </Col>
                                                    <Col md={10}>
                                                        <div className="side-nav-items">{items.name}</div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                </Col> */}
                                <Col className="pl-sm-0">
                                    {navItemsList.map((items, index) => (
                                        <div key={index}>
                                            {items.isActive && <Row>
                                                <Col md={3} className="spectial">
                                                    <img src={`${publicRuntimeConfig.staticFolder}/images/` + items.image} alt={items.alt}
                                                        className={(items.id == 1) ? "w-100 pt-5" : "w-100 mt-5 pt-1"} />
                                                </Col>
                                                <Col>
                                                    <div className="">
                                                        <div className={(items.id == 1) ? "company-name company-name-line spectial pt-5" : "company-name company-name-line pt-5"}>{items.name}</div>
                                                        {items.show ? <div>
                                                        <input type="checkbox" class="read-more-state" id={"post-3"+index} />
                                                        <div className="main-content pl-sm-0 read-more-wrap">{items.content}</div>
                                                        <label for={"post-3"+index} class="read-more-trigger"></label>
                                                        </div> : 
                                                        <div className="main-content pl-sm-0 read-more-wrap">{items.content}</div>}
                                                        <hr className="footer-divider mt-3" />
                                                        <div className="small-content">{items.ads}</div>
                                                        {/* <Link href="/case-study-details" as={"/"+items.cat_sulg}>
                                                            <div className="talk-content explore mt-sm-4">Explore
                                                            <img src={`${publicRuntimeConfig.staticFolder}/images/Path.svg`} alt="Path" className="ml-sm-1" />
                                                            </div>
                                                        </Link> */}
                                                    </div>
                                                </Col>
                                            </Row>}
                                        </div>
                                    ))}
                                    <br />
                                    <br />
                                    {/* <div className="text-center mobile-fg text-ssd">
                                    <div className="load-more">50+</div>
                                    <span className="more-cases">Case studies to be added shortly</span> <br />
                                    <span className="more-cases mt-0"></span>
                                    </div> */}

                                    <div className="text-center">
                                    <div className="load-more">50+
                                        <span className="">&nbsp;Case studies to be added shortly</span> <br />
                                        <span>Discover your ideas with us!</span>
                                    </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <TalkData image={true} title={<span>Got an idea? <br /> Talk to us!</span>} subtitle={<span>We’d love to talk about <br className="mobile" /> what matters to you.</span>} />
                </Layout>
                <style>
                    {`
                    body{
                        overflow-x: hidden
                    }
                    .ta9990pj{
                        font-size: 30px !important;
                        font-weight: 900;
                    }
                    .load-more{
                        -webkit-animation: color-change 1s infinite;
                        -moz-animation: color-change 1s infinite;
                        -o-animation: color-change 1s infinite;
                        -ms-animation: color-change 1s infinite;
                        animation: color-change 1s infinite;
                        font-size: 30px;
                        font-family: "PT Mono", monospace;
                        letter-spacing: 1px;
                        line-height: 60px;
                        font-weight: 600;
                        text-align: center;
                        width: fit-content;
                        margin: auto;
                        display: contents;
                    }
                    
                    @-webkit-keyframes color-change {
                        0% { color: #FF7400; }
                        50% { color: #FF7400; }
                        100% { color: #FF7400; }
                    }
                    @-moz-keyframes color-change {
                        0% { color: #FF7400; }
                        50% { color: #FF7400; }
                        100% { color: #FF7400; }
                    }
                    @-ms-keyframes color-change {
                        0% { color: #FF7400; }
                        50% { color: #FF7400; }
                        100% { color: #FF7400; }
                    }
                    @-o-keyframes color-change {
                        0% { color: #FF7400; }
                        50% { color: #FF7400; }
                        100% { color: #FF7400; }
                    }
                    @keyframes color-change {
                        0% { color: #FF7400; }
                        50% { color: #FF7400; }
                        100% { color: #FF7400; }
                    }
                    .more-cases{
                        font-family: "Encode Sans", sans-serif;
                        letter-spacing: 2px;
                        line-height: 0px;
                        font-weight: 500;
                        color: #292533;
                        margin-top: 35px;
                        position: absolute;
                        margin-left: 15px;
                        font-size: 17px;
                    }
                    .csd-head {
                        font-size: 129px;
                    }
                    @media only screen and (max-width: 768px){
                        .big-heading {
                            font-size: 45px !important;
                            line-height: 55px !important;
                            padding-bottom: 25px;
                            padding-top: 35px !important;
                        }
                        .mobile-wi-c{
                            width:90%
                        }
                        .more-cases{
                            line-height: 25px !important;
                            margin-top: 25px !important;
                        }
                    }
                    .main-content{
                        font-size: 18px;
                    }
                    .text-ssd{
                        margin-left: -180px;
                    }
                    `}
                </style>
            </div>
        )
    }
}
